'use client';

import type { Analytics } from '@segment/analytics-next';
import { useEffect } from 'react';

import { useAnalytics } from './hooks';

export function Track(props: {
  name: Parameters<Analytics['track']>[0];
  properties?: Parameters<Analytics['track']>[1];
  callback?: Parameters<Analytics['track']>[2];
}) {
  const analytics = useAnalytics();

  useEffect(() => {
    analytics.track(props.name, props.properties, props.callback);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return null;
}
